import {Component} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {icons} from "../../icons/Icons";
import {inject} from "../../services/di";
import {MIN_BROWSER_MAP} from "../../utils/browsers";
import {StorageService} from "../../services/StorageService";
import {ConfigService, RuntimeConfig} from "../../services/ConfigService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {DateTimeService} from "../../services/DateTimeService";

@element("flipp-old-browser-container")
export class OldBrowserContainer extends Component<{}, {}> {

	@inject storage: StorageService;
	@inject analytics: AnalyticsService;
	@inject config: ConfigService;
	@inject DateTimeService: DateTimeService;

	prepare() {
		let hideWarning = true;
		const isOldBrowser = bowser.isUnsupportedBrowser(MIN_BROWSER_MAP);
		const browserWarningDismissed = this.storage.getItem("oldBrowserWarningDismissed");

		if (isOldBrowser && !browserWarningDismissed) {
			hideWarning = false;
		}

		const oldBrowserBeacon = StorageService.getInstance().getItem("old_browser_beacon");
		let fireOldBrowserBeacon = false;
		try {
			const entry = JSON.parse(oldBrowserBeacon);
			const expired = !entry ? true : new Date().getTime() > Number(entry.expires_at);
			if (!entry || expired) {
				fireOldBrowserBeacon = true;
			}
		} catch (e) {
			fireOldBrowserBeacon = true;
		}

		if (isOldBrowser && fireOldBrowserBeacon) {
			const time = this.DateTimeService.getNow();
			StorageService.getInstance().setItem("old_browser_beacon", JSON.stringify({
				expires_at: time.plus({months: 1}).valueOf()
			}));

			// Fire a beacon at most once a month per user.
			// --------------------------------------------------------------------
			this.analytics.trackOldBrowser();
		}

		return hideWarning;
	}

	render(hideWarning: boolean) {
		if (hideWarning) {
			// Return null if no warning so we don't unecessarily render content into DOM and download assets
			return null;
		}

		return (
			<section class="old-browser-warning">
				<button class="dialog-close"
								title={i18n("close_dialog_button")}
								aria-label={i18n("close_dialog_button")}
								onClick={this._handleCloseButtonClick}>
						{icons.searchClose}
				</button>
				<img src="https://f.wishabi.net/creative/Distribution/images/sad-ice-cream-new.png" alt="image of a sad ice cream"/>
				<div class="old-browser-content">
					<div class="all-content" flex-horizontal flex-wrap>
						<div class="text-content">
							<p class="old-browser-warning-msg">{i18n("old_browser_warning_msg")}</p>
							<p class="old-browser-latest-tech-msg">{i18n(`${this.config.RUNTIME === RuntimeConfig.PG ? "pg_" : ""}old_browser_latest_tech_msg`)}</p>
							<p class="old-browser-cta">{i18n("old_browser_cta")}</p>
						</div>
						<div class="links-content">
							<a href="http://www.google.com/chrome" target="_blank">
								<img class="browser-img" src="https://f.wishabi.net/creative/Distribution/images/browsers/google-chrome.png" alt="Google Chrome Logo"/>
								<p>Google Chrome</p>
							</a>
							<a href="http://www.mozilla.org/firefox" target="_blank">
								<img class="browser-img" src="https://f.wishabi.net/creative/Distribution/images/browsers/mozilla-firefox.png" alt="Mozilla Firefox Logo"/>
								<p>Mozilla Firefox</p>
							</a>
							<a href="http://support.microsoft.com/en-us/help/17621/internet-explorer-downloads" target="_blank">
								<img class="browser-img" src="https://f.wishabi.net/creative/Distribution/images/browsers/ms-edge.png" alt="Microsoft Edge Logo"/>
								<p>Microsoft Edge</p>
							</a>
							<a href="http://support.apple.com/downloads/safari" target="_blank">
								<img class="browser-img" src="https://f.wishabi.net/creative/Distribution/images/browsers/apple-safari.png" alt="Apple Safari Logo"/>
								<p>Apple Safari</p>
							</a>
						</div>
					</div>
				</div>
			</section>
		);
	}

	private _handleCloseButtonClick = (e: Event) => {
		e.preventDefault();
		this.storage.setItem("oldBrowserWarningDismissed", "true");
		this.invalidate();
	}
}
